export default "__VITE_ASSET__DQegQlSY__"